import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { Box, Tooltip } from "@mui/material"; // Make sure Typography is imported
import IconButton from "@mui/material/IconButton";
import { MaterialReactTable } from "material-react-table";
import { useState } from "react";
import { StyledProvider } from "../../styled/providers";
import ArtInProvider from "../../ui/providers/artInProvider";
import { tableConfig } from "./config/tableConfig";
import TitleContainer from "./utilsTable/titleWithFetchData";

const ProvidersTable = ({
  data,
  loading,
  fetchData,
  handleOpenEdit,
  handleDelete,
}) => {
  const [columnObject] = useState([
    {
      header: "Razón social",
      accessorKey: "nombre",
      Cell: ({ row }) => row.original.nombre,
    },
    {
      header: "Acciones",
      Cell: ({ row }) => (
        <Box display="flex">
          <Tooltip title="Editar Prestador">
            <IconButton
              color="inherit"
              onClick={() => handleOpenEdit(row.original)}
              aria-label="edit">
              <EditIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Eliminar Prestador">
            <IconButton
              color="inherit"
              onClick={() => handleDelete(row.original)}
              aria-label="delete">
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        </Box>
      ),
    },
  ]);

  return (
    <div>
      <MaterialReactTable
        {...tableConfig}
        columns={columnObject}
        data={data}
        state={{ isLoading: loading }}
        renderTopToolbarCustomActions={() => (
          <Box m={0.5}>
            <TitleContainer title="Prestadores" fetchData={fetchData} />
          </Box>
        )}
        renderDetailPanel={({ row }) => (
          <StyledProvider.ArtInProviderContainer>
            <ArtInProvider provider={row.original} refresh={fetchData} />
          </StyledProvider.ArtInProviderContainer>
        )}
      />
    </div>
  );
};

export default ProvidersTable;
